export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);

  link.click();

  link.parentNode?.removeChild(link);
  window.URL.revokeObjectURL(url);
};
